import React from 'react';
import { Typography } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import IconRedirect from 'crono-fe-common/icons/Icon-Redirect';

interface IProps {
  redirectText: string;
  onClick: () => void;
  showRedirectIcon?: boolean;
  showBorder?: boolean;
}

const InsightsAccordionFooter = ({
  redirectText,
  onClick,
  showRedirectIcon = true,
  showBorder = false,
}: IProps) => {
  return (
    <div
      className={`insights-bottom-footer ${!showBorder ? 'top-border' : ''}`}
      onClick={(ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        onClick();
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          minWidth: 'fit-content',
        }}
      >
        <Typography fontSize={'12px'} fontWeight={500} color={colors.darkGreen}>
          {redirectText}
        </Typography>
        {showRedirectIcon && (
          <span className="redirect-icon-wrapper">
            <IconRedirect
              style={{
                width: 16,
                height: 16,
              }}
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default InsightsAccordionFooter;
